import axios from 'axios';
import { withFlash } from './flash.js';
import { hideLoading } from './notify.js';

const http = axios.create({
  baseURL: '/api/v1',
  withCredentials: true
});

// A 401 outside the login form means the session died while the page was open.
// Send the user to /login with an explanation instead of a bare error toast.
http.interceptors.response.use(
  (response) => response,
  (error) => {
    // Deliberately the whole /auth/login family, not the one path: the passkey
    // ceremonies answer 401 on a failed assertion or an expired second step,
    // and redirecting there would bounce the user out of the login page
    // mid-ceremony. Every one of those routes starts with /auth/login, so this
    // prefix check covers them - do not narrow it back to an equality test.
    const isLoginRequest = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !isLoginRequest) {
      hideLoading();
      window.location.href = withFlash('/login', 'sitzung-abgelaufen');
    }
    return Promise.reject(error);
  }
);

export default http;
